/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { makeStyles } from '@material-ui/core';
import React from 'react';
import DOMPurify from 'dompurify';
import { ConfigResourceProps } from '../../redux/enums/ConfigResourceProps';
import { useConfiguration } from '../../redux/features/configuration/useConfiguration';
import { getInternationalizedResource, getDefaultLanguageResource } from '../../shared/utils/i18nUtils';
import { resourceKeys } from '../../shared/enums/resourceKeys';

const useStyles = makeStyles(theme => ({
  accessibilityContainer: {
    paddingTop: '4rem',
    paddingBottom: '4rem',
    paddingLeft: '10rem',
    maxWidth: '50%',

    '& hr': {
      border: `1px solid ${theme.palette.border}`,
    },

    [theme.breakpoints.down('sm')]: {
      paddingTop: '2rem',
      paddingLeft: '3rem',
      maxWidth: '80%',
    },

    [theme.breakpoints.down('md')]: {
      paddingTop: '2.5rem',
      paddingLeft: '4rem',
      maxWidth: '80%',
    },

    [theme.breakpoints.down('lg')]: {
      paddingTop: '3rem',
      paddingLeft: '4.5rem',
      maxWidth: '70%',
    },
  },
}));

export default function AccessibilityStatementPage() {
  const classes = useStyles();

  const configResource =
    ConfigResourceProps[getInternationalizedResource(resourceKeys.ACCESSIBILITY_STATEMENT.RESOURCE_KEY)] ||
    ConfigResourceProps[getDefaultLanguageResource(resourceKeys.ACCESSIBILITY_STATEMENT.RESOURCE_KEY)];
  const statementResource = useConfiguration(configResource);

  return (
    <div
      data-testId="accessibility-statement"
      className={classes.accessibilityContainer}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(statementResource.resource) }}
    />
  );
}
